import { FC, ReactNode, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import LoadingLayout from "./LoadingLayout";

interface AuthProviderProps {
	children: ReactNode;
}

const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
	const { instance, inProgress } = useMsal();
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		const initializeAuth = async () => {
			try {
				const response = await instance.handleRedirectPromise();

				if (response?.account) {
					instance.setActiveAccount(response.account);
				} else {
					const accounts = instance.getAllAccounts();
					if (accounts.length > 0) {
						instance.setActiveAccount(accounts[0]);
					}
				}
			} catch (error) {
				console.error("MSAL redirect handling failed:", error);
			} finally {
				setLoaded(true);
			}
		};

		if (inProgress === InteractionStatus.None) {
			initializeAuth();
		}
	}, [instance, inProgress]);

	// showing loading screen while auth is initializing
	if (!loaded) return <LoadingLayout />;

	return <>{children}</>;
};

export default AuthProvider;
